import {Checkbox, FormControlLabel, Radio, Switch, Tooltip, Typography} from '@mui/material'
import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {OcFormControlProps, getTypographyColor} from './utils'

function getControl(props: OcFormControlProps): React.ReactElement {
    const controlProps: {
        size?: 'small' | 'medium'
        color?: 'primary' | 'secondary' | 'default'
        onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
        checked?: boolean
        disabled?: boolean
        style: Record<string, any>
    } = {
        size: props.controlSize,
        color: props.controlColor || 'primary',
        onChange: props.onChange,
        checked: props.checked,
        disabled: props.disabled,
        style: {
            alignSelf: 'baseline',
            ...props.controlStyle
        }
    }

    let control: JSX.Element | undefined = undefined
    switch (props.controlType) {
        case 'checkbox':
            control = <Checkbox indeterminate={!!props.checkboxIndeterminate} {...controlProps} />
            break
        case 'radio':
            control = <Radio {...controlProps} />
            break
        case 'switch':
            control = <Switch {...controlProps} />
            break
    }

    if (props.tooltip) {
        return (
            <Tooltip title={props.tooltip}>
                <span>{control}</span>
            </Tooltip>
        )
    }
    return control
}

function _OcFormControl(props: OcFormControlProps) {
    const {
        typoVariant,
        typoColor: _typoColor,
        label,
        controlType: _controlType,
        controlSize: _controlSize,
        checkboxIndeterminate: _checkboxIndeterminate,
        controlColor: _controlColor,
        tooltip: _tooltip,
        controlStyle: _controlStyle,
        onChange: _onChange,
        ...restProps
    } = props
    return (
        <FormControlLabel
            {...restProps}
            label={
                <Typography
                    variant={typoVariant ? typoVariant : 'body1'}
                    color={getTypographyColor(props)}
                    style={{overflowWrap: 'anywhere'}}
                >
                    {label}
                </Typography>
            }
            checked={props.checked}
            disabled={props.disabled}
            control={getControl(props)}
        />
    )
}

export const OcFormControl = observer(_OcFormControl)
export const OcFormSwitch = (props: Omit<OcFormControlProps, 'controlType' | 'checkboxIndeterminate'>) => (
    <OcFormControl controlType="switch" {...props} />
)
export const OcFormRadio = (props: Omit<OcFormControlProps, 'controlType' | 'checkboxIndeterminate'>) => (
    <OcFormControl controlType="radio" {...props} />
)
export const OcFormCheckbox = (props: Omit<OcFormControlProps, 'controlType'>) => (
    <OcFormControl controlType="checkbox" {...props} />
)
